import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PriceSort, PriceSortDirection } from 'src/app/models/results/price-sort';

@Injectable({
  providedIn: 'root'
})
export class SortingService {
  private readonly _currentPriceSort = new BehaviorSubject<PriceSort>(new PriceSort(PriceSortDirection.LowToHigh));
  readonly currentPriceSort$ = this._currentPriceSort.asObservable();

  private get currentPriceSort(): PriceSort {
    return this._currentPriceSort.getValue();
  }

  private set currentPriceSort(val: PriceSort) {
    this._currentPriceSort.next(val);
  }

  constructor() { }

  updateCurrentPriceSort(priceSort: PriceSort): void {
    if (this.currentPriceSort.sortDirection !== priceSort.sortDirection) {
      this.currentPriceSort = priceSort;
    }
  }
}
